/**
 *  Component - SelectedEmployeeCard
 *
 *  @param {empName} EmpName displayed at center
 *  @param {empId} EmpId shown below EmpName
 *  @param {empMail} EmpMail shown below EmpId
 *  @param {currCTC} Current CTC shown below EmpMail
 *  In slots we need to give Revised Salary and Effective Date when exists.
 *
 * Usage:
 * <!--
 *  <ctc-details-card
 *      empName="Chetna Garg"
 *      empId="745432"
 *      empMail="ChetnaGarg@gmail.com"
 *      @click="{function_name}"
 *  >
 * <template>
 *  Your own html (In this case Revised Salary and Effective Date when it exists)
 * </template>
 *  </ctc-details-card>  -->
 *
 */

<template>
    <div>
        <div class="card">
            <div class="image">
                <img v-if="photo_url" :src="photo_url" class="alignImage">
                <img v-else src="@/assets/user.svg" class="alignImage">
            </div>
            <div class="emp-details">
                <span> <b> {{ empName }} </b> </span><br>
                <span class="details"> {{ empId }} </span><br>
                <span class="details"> {{ empMail }} </span><br>
                <span class="details" v-show="ctcDetails"> Current CTC : <b>{{ currCTC }}/- Per Annum </b> </span>
                <span class="details" v-show="ctcDetails"> Effective Date : <b>{{ effDate }} </b> </span>
                <slot name="revisedCtc"></slot>
                <slot name="fixedNonCtc"></slot>
            </div>

            <div class="close-card" v-on:click="$emit('click')">
                <span> x </span>
            </div>
        </div>
     </div>
</template>

<script>
export default {
    name: 'CtcDetailsCard',
    props: {
        photo_url : {
            type: String
        },
        empName : {
            type: String
        },
        empId: {
            type: String
        },
        empMail: {
            type: String
        },
        currCTC: {
            type: String | Number
        },
        effDate: {
            type: String | Number
        },
        ctcDetails: {
            type: Boolean,
            default: true
        }
    }

}
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  min-width: 320px;
  max-width: min-content;
  margin-right: 12px;
  height: 120px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  position: relative;
}
.image{
    .alignImage {
        width: 80px;
        height: 80px;
        margin: 18px 0 0 15px;
        border-radius: 50px;
    }
}
.emp-details {
    padding: 10px 0 0 10px;
    color: #535353;
}
.details {
    color: #535353;
    font-size: 11px;
        b {
            color: #535353;
        }
}
.close-card {
    position: absolute;
    top: 8px;
    right: 25px;
    cursor: pointer;
    color: #6e6e6e;
    width: 12px;
    height: 12px;
    padding: 2px 0 0 30px;
}
</style>
